import React from 'react';
import Translation from '../../../../translation/translation';

function EditLabel() {
    return (
        <Translation
            translationKey="catalog-statusbar-mobile-edit-postcode-label"
            className="statusbar-mobile-current-status__postcode-label"
        />
    );
}

export { EditLabel };
